import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    title: 'Destruye tu sistema de dopamina',
    desc: 'baja motivación para metas reales'
  }, {
    title: 'Erosiona la intimidad',
    desc: 'y la confianza con tu pareja'
  }, {
    title: 'Reduce tu sensibilidad',
    desc: 'al placer real y físico'
  }, {
    title: 'Distorsiona tu percepción',
    desc: 'del sexo y las relaciones humanas'
  }, {
    title: 'Aumenta la ansiedad',
    desc: 'depresión y sentimientos de inferioridad'
  }];
  return <section className="bg-dark-alt py-24" data-id="element-108">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-109">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.5
      }} data-id="element-110">
          <h2 className="font-display text-3xl md:text-5xl font-bold text-center mb-16 uppercase" data-id="element-111">
            La pornografía está destruyendo tu vida{' '}
            <span className="text-accent" data-id="element-112">más de lo que crees</span>
          </h2>

          <div className="space-y-6" data-id="element-113">
            {problems.map((problem, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-start gap-4 bg-dark-card p-6 rounded-xl border border-dark-border" data-id="element-114">
                <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-115" />
                <div data-id="element-116">
                  <span className="font-bold text-lg text-white" data-id="element-117">
                    {problem.title}
                  </span>
                  <span className="text-gray-400 text-lg" data-id="element-118">
                    {' '}
                    → {problem.desc}
                  </span>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}